import { Component, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private router = inject(Router);
  isHomePage = true;
  isBanamexRegistration = false;
  pageTitle = '';

  private banamexAccounts = ['2228', '2665', '2559', '2907', '2988'];
  private registrationPages = ['register', 'code-banamex', 'form-register-banamex'];

  ngOnInit() {
    this.checkRoute();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkRoute();
      });
  }

  private checkRoute() {
    const url = this.router.url;
    this.isHomePage = url === '/' || url === '/nuevacontrasena' || url === '/codigocontrasena';
    
    const accountId = this.getAccountFromUrl();
    const currentPage = this.getCurrentPage();
    
    this.isBanamexRegistration = accountId !== null && 
                                this.banamexAccounts.includes(accountId) && 
                                this.registrationPages.includes(currentPage);
    
    this.setPageTitle(currentPage);
  }

  private getAccountFromUrl(): string | null {
    const url = this.router.url;
    const accountMatch = url.match(/uuidc=(\d+)/);
    return accountMatch ? accountMatch[1] : null;
  }

  private getCurrentPage(): string {
    const url = this.router.url;
    if (url.includes('registro')) return 'register';
    if (url.includes('code-banamex')) return 'code-banamex';
    if (url.includes('form-register-banamex')) return 'form-register-banamex';
    return '';
  }

  private setPageTitle(page: string) {
    const titles: { [key: string]: string } = {
      'register': 'Registro',
      'code-banamex': 'Código de verificación',
      'form-register-banamex': 'Datos del registro'
    };
    this.pageTitle = titles[page] || '';
  }

  goBack() {
    window.history.back();
  }

  goToHome() {
    const accountId = this.getAccountFromUrl();
    if (accountId && this.banamexAccounts.includes(accountId)) {
      this.router.navigate(['/'], { queryParams: { uuidc: accountId } });
    } else {
      this.router.navigate(['/']);
    }
  }
}
